export default __webpack_public_path__ + "static/browser-rain-trees-52c9d631d467757b357b301ecec39ce0.png";